module.exports = __webpack_public_path__ + "img/bot_info.2d42040c.png";